import { render } from "./IconExcel.vue?vue&type=template&id=2c024fa8"
import script from "./IconExcel.vue?vue&type=script&lang=ts"
export * from "./IconExcel.vue?vue&type=script&lang=ts"
script.render = render

export default script